import { FC } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import PruRoute from 'src/app/common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { OPM_PD_BASE_PATH, POLICY_TRANSFER_REQUEST_PATH } from '../../constants';
import BatchFilesPage from './BatchFiles/BatchFilesPage';
import { batchFilesFilterKeys } from './BatchFiles/useBatchFilesPage';
import BatchFilesSubmitPage from './BatchFilesSubmit/BatchFilesSubmitPage';
import BatchFilesViewPage from './BatchFilesView/BatchFilesViewPage';
import ReassignAgentForHoldPolicies from './ReassignAgentForHoldPolicies/ReassignAgentForHoldPolicies';

export const policyRequestTransferPath = `${OPM_PD_BASE_PATH}${POLICY_TRANSFER_REQUEST_PATH}`;

const PolicyRequestTransferRoutes: FC = () => {
  return (
    <Switch>
      <Redirect exact from={policyRequestTransferPath} to={`${policyRequestTransferPath}/batch-files`} />
      <PruRoute
        exact
        path={`${policyRequestTransferPath}/batch-files`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={batchFilesFilterKeys}>
            <BatchFilesPage />
          </ParamsProvider>
        )}
      />
      <PruRoute
        exact
        path={`${policyRequestTransferPath}/batch-files/:bdmBatchFileId/submit`}
        render={() => <BatchFilesSubmitPage />}
      />
      <PruRoute
        exact
        path={`${policyRequestTransferPath}/batch-files/:bdmBatchFileId/view`}
        render={() => <BatchFilesViewPage />}
      />
      <PruRoute
        exact
        path={`${policyRequestTransferPath}/batch-files/reassign-agent-for-hold-policies`}
        render={() => <ReassignAgentForHoldPolicies />}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default PolicyRequestTransferRoutes;
